import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setSnackbar } from 'shared/store/slices/snackBarSlice';

/**
 * Returns a `notifyMismatch` callback for the object/date/number `valueParser`s in
 * `shared/lib/datagridHelpers`: warns (via snackbar) that a pasted value didn't match
 * the field's format and was ignored. `field.label` is the grid header shown to the user.
 */
const useFormatMismatchWarning = () => {
    const dispatch = useDispatch();

    return useCallback(
        (field) => {
            dispatch(
                setSnackbar({
                    open: true,
                    message: `"${field.label}" — pasted value doesn't match this field's format; ignored.`,
                    severity: 'warning',
                })
            );
        },
        [dispatch]
    );
};

export default useFormatMismatchWarning;
